export default __webpack_public_path__ + "static/media/hero.160610bb.jpg";